import React, { useState } from 'react';
import dayjs from "dayjs";
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Image from '../../components/Image';
import { basePageWrap } from '../BasePage';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Breadcrumbs from '../../components/Breadcrumbs';
import PageNavigation from '../../components/PageNavigation';
import SideCardLink from '../../components/SideCardLink';
import RawHtml from '../../components/RawHtml';
import FeedbackForm from '../../components/FeedbackForm';
import SupportForm from '../../components/SupportForm';
import styles from './ArticlePage.module.scss';

const ArticlePage = ({ settings = {
        hero: {},
        footer: {}
    }, publishedDate, image, title, preamble, breadcrumbs = {
        links: []
    }, richText, sidebar, form }) => {
    const showMenu = sidebar && sidebar.navigation && sidebar.navigation.items && sidebar.navigation.items.length > 1;

    return (
        <div className={styles['ArticlePage']}>
            <Header {...settings.header} />
            <main>
                <div className={styles['ArticlePage__Container']}>
                    <div className={styles['ArticlePage__Breadcrumbs']}>
                        <Breadcrumbs {...breadcrumbs} />
                    </div>
                    <div className={styles['ArticlePage__Wrap']}>
                        {image && (
                            <div className={styles['ArticlePage__ImageWrap']}>
                                <div className={styles['ArticlePage__Image']}>
                                    <Image
                                        {...image}
                                        layout="fill"
                                        objectFit="cover"
                                    />
                                </div>
                                {image.caption && (
                                    <span className={styles['ArticlePage__ImageCaption']}>
                                        {image.caption}
                                    </span>
                                )}
                            </div>
                        )}
                        <div className={styles['ArticlePage__ContentWrap']}>
                            <h1 className={styles['ArticlePage__Title']}>{title}</h1>
                            {publishedDate && (
                                <span className={styles['ArticlePage__Published']}>
                                    Published {dayjs(publishedDate).format("DD MMMM YYYY")}
                                </span>
                            )}
                            {showMenu && (
                                <div className={styles['ArticlePage__MobileNavigation']}>
                                    <PageNavigation {...sidebar.navigation} />
                                </div>
                            )}
                            <div className={styles['ArticlePage__Content']}>
                                <div className={styles['ArticlePage__Text']}>
                                    <p className={styles['ArticlePage__Preamble']}>{preamble}</p>
                                    {richText && (
                                        <div className={styles['ArticlePage__RichText']}>
                                            <RawHtml html={richText} />
                                        </div>
                                    )}

                                    {form && form.type && (
                                        <div className={styles['ArticlePage__Form']}>
                                            {form.type === "feedback" && (
                                                <FeedbackForm {...form} />
                                            )}
                                            {form.type === "support" && (
                                                <SupportForm {...form} />
                                            )}
                                        </div>
                                    )}
                                </div>

                                <aside className={styles['ArticlePage__Sidebar']}>
                                    {showMenu && (
                                        <div
                                            className={
                                                classNames([
                                                    styles['ArticlePage__SidebarItem'],
                                                    styles['ArticlePage__SidebarItem--Desktop']
                                                ])}
                                        >
                                            <PageNavigation {...sidebar.navigation} />
                                        </div>
                                    )}
                                    {sidebar && sidebar.cards && sidebar.cards.map((card, index) => (
                                        <div
                                            key={index}
                                            className={styles['ArticlePage__SidebarItem']}
                                        >
                                            <SideCardLink {...card} />
                                        </div>
                                    ))}
                                </aside>
                            </div>
                        </div>
                    </div>
                </div>

            </main>
            <Footer {...settings.footer} />
        </div>
    );
};

ArticlePage.propTypes = {
    title: PropTypes.string,
    preamble: PropTypes.string,
    breadcrumbs: PropTypes.object,
    settings: PropTypes.object,
    image: PropTypes.object,
    sidebar: PropTypes.object,
    publishedDate: PropTypes.string,
};

export default basePageWrap(ArticlePage);
